module.exports = __webpack_public_path__ + "img/ELLA.8d6a05e3.svg";